import * as React from "react";
export default function ArticleContentIguReplacement() {
  return <section data-section-id="257741" id="contenido" className="py-12 md:py-16 lg:py-20 bg-background text-foreground">
      <div className="page-container max-w-3xl mx-auto">

        {/* Fecha */}
        <p className="text-sm text-muted-foreground/70 mb-8 font-default">Última actualización: 01 de enero 2026</p>

        {/* Introducción */}
        <div className="space-y-6 text-base md:text-lg text-muted-foreground leading-relaxed font-default">
          <p>
            En cumplimiento con lo dispuesto por la Ley Federal de Protección de
            Datos Personales en Posesión de los Particulares (LFPDPPP), su
            Reglamento y demás normatividad aplicable, Fulcro pone a su
            disposición el presente Aviso de Privacidad.
          </p>
        </div>

        {/* 1. Identidad del responsable */}
        <h2 className="text-2xl md:text-3xl font-bold text-secondary mt-12 mb-6 font-default">
          1. Identidad del responsable
        </h2>
        <div className="space-y-6 text-base md:text-lg text-muted-foreground leading-relaxed font-default">
          <p>La marca <strong data-ast-id="f:/src/pages/PrivacyNotice/sections/ArticleContentIguReplacement.tsx|sig:x7xdoh" data-ast-start="1243" data-ast-end="1266">Fulcro</strong> (en adelante, "Fulcro" o "nosotros"), con domicilio en Retorno Caracol No. 3 Sm. 27 Mz. 8 Lt. 15 Cancún, Quintana Roo, es el responsable del uso, tratamiento y protección de los datos personales que usted nos proporcione.</p>
          <p>Para cualquier asunto relacionado con este aviso, puede contactarnos en: hola@fulcro.mx</p>
        </div>

        {/* 2. Datos personales que recabamos */}
        <h2 className="text-2xl md:text-3xl font-bold text-secondary mt-12 mb-6 font-default">
          2. Datos personales que recabamos
        </h2>
        <div className="space-y-6 text-base md:text-lg text-muted-foreground leading-relaxed font-default">
          <p>
            Para las finalidades señaladas en este aviso, podemos recabar los
            siguientes datos personales:
          </p>
          <ul className="list-disc pl-6 space-y-2 marker:text-secondary">
            <li>
              <strong>A través de formularios de contacto:</strong> nombre
              completo, correo electrónico, número telefónico, empresa, puesto y
              cualquier información que usted decida incluir en el mensaje.
            </li>
            <li>
              <strong>De forma automática durante su navegación:</strong>{" "}
              dirección IP, tipo de navegador y dispositivo, sistema operativo,
              páginas visitadas, tiempo de permanencia, fuente de referencia y
              datos derivados del uso de cookies y tecnologías similares.
            </li>
          </ul>
          <p>
            Fulcro <strong>no recaba datos personales sensibles</strong> a
            través de su sitio web. Se consideran datos sensibles, conforme a la
            LFPDPPP, aquellos que puedan revelar origen racial o étnico, estado
            de salud, información genética, creencias religiosas o filosóficas,
            afiliación sindical, opiniones políticas y preferencia sexual.
          </p>
        </div>

        {/* 3. Finalidades */}
        <h2 className="text-2xl md:text-3xl font-bold text-secondary mt-12 mb-6 font-default">
          3. Finalidades del tratamiento
        </h2>
        <div className="space-y-6 text-base md:text-lg text-muted-foreground leading-relaxed font-default">
          <p>
            <strong>Finalidades primarias</strong> (necesarias para la relación
            con usted):
          </p>
          <ul className="list-disc pl-6 space-y-2 marker:text-secondary">
            <li>
              Responder a solicitudes de información, cotizaciones y propuestas
              comerciales.
            </li>
            <li>
              Prestar los servicios de consultoría, implementación y
              automatización contratados.
            </li>
            <li>Brindar acceso y soporte a nuestros productos SaaS.</li>
            <li>
              Emitir facturación y cumplir con obligaciones fiscales y legales.
            </li>
            <li>
              Gestionar la comunicación operativa derivada de los servicios
              prestados.
            </li>
          </ul>
          <p>
            <strong>Finalidades secundarias</strong> (no necesarias, pero nos
            ayudan a mejorar):
          </p>
          <ul className="list-disc pl-6 space-y-2 marker:text-secondary">
            <li>
              Envío de comunicaciones comerciales, boletines y contenido
              relacionado con nuestros servicios.
            </li>
            <li>
              Realizar análisis estadísticos y mejorar la experiencia en
              nuestro sitio.
            </li>
          </ul>
          <p>Si no desea que sus datos sean tratados para las finalidades secundarias, puede manifestarlo enviando un correo a&nbsp;hola@fulcro.mx. Su negativa no será motivo para negarle los servicios solicitados.</p>
        </div>

        {/* 4. Transferencias */}
        <h2 className="text-2xl md:text-3xl font-bold text-secondary mt-12 mb-6 font-default">
          4. Transferencias de datos
        </h2>
        <div className="space-y-6 text-base md:text-lg text-muted-foreground leading-relaxed font-default">
          <p>
            Sus datos personales pueden ser transferidos a proveedores de
            servicios tecnológicos que nos asisten en la operación del negocio,
            incluyendo plataformas de automatización, alojamiento en la nube,
            herramientas de comunicación, CRM, análisis web y publicidad
            digital. Algunos de estos proveedores se encuentran ubicados fuera
            del territorio nacional (principalmente en Estados Unidos y la Unión
            Europea), y operan bajo estándares de seguridad y privacidad
            conformes a sus respectivas regulaciones, así como bajo cláusulas
            contractuales que garantizan la confidencialidad y el cumplimiento
            de la LFPDPPP.
          </p>
          <p>
            No realizamos transferencias de datos que requieran su
            consentimiento conforme al artículo 37 de la LFPDPPP, salvo
            aquellas previstas por la ley.
          </p>
        </div>

        {/* 5. Derechos ARCO */}
        <h2 className="text-2xl md:text-3xl font-bold text-secondary mt-12 mb-6 font-default">
          5. Derechos ARCO
        </h2>
        <div className="space-y-6 text-base md:text-lg text-muted-foreground leading-relaxed font-default">
          <p>
            Usted tiene derecho a <strong>Acceder</strong> a sus datos
            personales, <strong>Rectificarlos</strong> cuando sean inexactos,{" "}
            <strong>Cancelarlos</strong> cuando considere que no se requieren
            para alguna de las finalidades señaladas, así como a{" "}
            <strong>Oponerse</strong> a su tratamiento para fines específicos.
          </p>
          <p>Para ejercer estos derechos, envíe su solicitud a&nbsp;hola@fulcro.mx&nbsp;incluyendo: (i) nombre y medio de contacto, (ii) documento que acredite su identidad, (iii) descripción clara de los datos y derecho que desea ejercer.</p>
          <p>
            Daremos respuesta a su solicitud en un plazo máximo de 20 días
            hábiles.
          </p>
        </div>

        {/* 6. Revocación del consentimiento */}
        <h2 className="text-2xl md:text-3xl font-bold text-secondary mt-12 mb-6 font-default">
          6. Revocación del consentimiento
        </h2>
        <div className="space-y-6 text-base md:text-lg text-muted-foreground leading-relaxed font-default">
          <p>Usted puede revocar en cualquier momento el consentimiento que nos haya otorgado para el tratamiento de sus datos personales, enviando su solicitud a&nbsp;hola@fulcro.mx. Es posible que, por obligaciones legales, debamos conservar ciertos datos aun después de la revocación.</p>
        </div>

        {/* 7. Cookies */}
        <h2 className="text-2xl md:text-3xl font-bold text-secondary mt-12 mb-6 font-default">
          7. Uso de cookies y tecnologías similares
        </h2>
        <div className="space-y-6 text-base md:text-lg text-muted-foreground leading-relaxed font-default">
          <p>
            Nuestro sitio utiliza cookies propias y de terceros para mejorar la
            experiencia de navegación, analizar el uso del sitio y mostrar
            publicidad relevante. Las categorías de cookies que utilizamos son:
          </p>
          <ul className="list-disc pl-6 space-y-2 marker:text-secondary">
            <li>
              <strong>Cookies estrictamente necesarias:</strong> indispensables
              para el funcionamiento básico del sitio.
            </li>
            <li>
              <strong>Cookies analíticas:</strong> nos permiten conocer cómo
              interactúan los visitantes con el sitio (por ejemplo, mediante
              Google Analytics). Recaban información de forma agregada y
              anónima.
            </li>
            <li>
              <strong>Cookies de publicidad y remarketing:</strong> utilizadas
              por servicios como Google Ads y Meta para mostrarle anuncios
              relevantes de Fulcro en otros sitios web y plataformas, basados
              en su navegación previa en nuestro sitio.
            </li>
          </ul>
          <p>
            Puede deshabilitar las cookies desde la configuración de su
            navegador. Adicionalmente, puede gestionar sus preferencias de
            publicidad personalizada en:
          </p>
          <ul className="list-disc pl-6 space-y-2 marker:text-secondary">
            <li>
              Google:{" "}
              <a href="https://adssettings.google.com" className="underline hover:text-primary transition-colors">
                adssettings.google.com
              </a>
            </li>
            <li>
              Meta:{" "}
              <a href="https://www.facebook.com/adpreferences" className="underline hover:text-primary transition-colors">
                facebook.com/adpreferences
              </a>
            </li>
          </ul>
          <p>
            Considere que deshabilitar ciertas cookies puede afectar algunas
            funciones del sitio.
          </p>
        </div>

        {/* 8. Cambios al aviso */}
        <h2 className="text-2xl md:text-3xl font-bold text-secondary mt-12 mb-6 font-default">
          8. Cambios al aviso de privacidad
        </h2>
        <div className="space-y-6 text-base md:text-lg text-muted-foreground leading-relaxed font-default">
          <p>
            Fulcro se reserva el derecho de modificar este Aviso de Privacidad
            en cualquier momento. Las actualizaciones serán publicadas en esta
            misma página, indicando la fecha de última modificación. Le
            recomendamos revisarla periódicamente.
          </p>
        </div>

        {/* Nota INAI */}
        

      </div>
    </section>;
}